// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import ChatbotTranscript from "entity/ChatbotTranscript";
import Prompt, { processPromptArray } from "entity/Prompt";

export default interface ChatbotTranscripts {
    transcripts?: ChatbotTranscript[];
    prompts?: Prompt[];
}

export function processChatbotTranscripts(value?: ChatbotTranscripts): void {
  if (value) {
    processPromptArray(value.prompts);
  }
}
